import React from 'react';
import { connect } from 'react-redux';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//components
import Industry from '../components/industry/Industry';
//styles
import 'bootstrap/dist/css/bootstrap.css';
import './industries.styl';
//images
import aircheckr_auto from '../media/industry/aircheckr-auto-white.png';
import aircheckr_ho from '../media/industry/aircheckr-h&o-white.png';
import aircheckr_health from '../media/industry/aircheckr-health-white.png';
import aircheckr_info from '../media/industry/aircheckr-info-white.png';
import aircheckr_intelli from '../media/industry/aircheckr-intelli-white.png';
import aircheckr_outdoor from '../media/industry/aircheckr-outdoor-white.png';
//text
import { IndustriesPageText as IndustriesPageTextEN } from '../input-text/en/industries_page';
import { IndustriesPageText as IndustriesPageTextNL  } from '../input-text/nl/industries_page';

class Industries extends React.Component {
  constructor(props) {
    super(props);
    this.setLocale = this.setLocale.bind(this);
  }

  componentWillMount() {
      switch (this.props.lang) {
          case 'nl':
              this.props.setLocale(this.props.lang, true);
              break;
          default: this.props.setLocale(this.props.locale, true);
      }
  }

  componentWillUnmount() {
      this.props.setLocale(this.props.locale, false);
  }

  setLocale(locale) {
      this.IndustriesPageText = null;
      switch (this.props.locale) {
          case 'en':
              this.IndustriesPageText = IndustriesPageTextEN;
              break;
          case 'nl':
              this.IndustriesPageText = IndustriesPageTextNL;
              break;
          default:
              this.IndustriesPageText = IndustriesPageTextEN;
      }
  }

  render(){
    this.setLocale(this.props.locale);

    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='hidden-xs col-sm-4 header-image-container industries-header'>
            <img src={aircheckr_ho} alt='ho' />
            <img src={aircheckr_info} alt='info' />
            <img src={aircheckr_outdoor} alt='outdoor' />
            <img src={aircheckr_health} alt='health' />
            <img src={aircheckr_auto} alt='auto' />
            <img src={aircheckr_intelli} alt='intelli' />
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{this.IndustriesPageText._1}</h1>
            <p>{this.IndustriesPageText._2}</p>
          </div>
        </SimpleContainer>
        <SimpleContainer color='white' containerClass='industry-big-list-container padded-container'>
          <Industry industry='homeandoffice' />
          <Industry industry='info' />
          <Industry industry='outdoor' />
          <Industry industry='health' />
          <Industry industry='auto' />
          <Industry industry='intelli' />
        </SimpleContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale, hasTranslation) => dispatch({
      type: 'UPDATE_LOCALE',
      locale,
      hasTranslation,
    }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Industries);



// WEBPACK FOOTER //
// ./src/routes/Industries.js